import { render } from "./sidenav.html?vue&type=template&id=4850c5bd&scoped=true&lang=html&external"
import script from "./sidenav.component.vue?vue&type=script&lang=js"
export * from "./sidenav.component.vue?vue&type=script&lang=js"

import "./_sidenav.mobile.scss?vue&type=style&index=0&id=4850c5bd&lang=scss&scoped=true&external"
import "./_sidenav.desktop.scss?vue&type=style&index=1&id=4850c5bd&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4850c5bd"]])

export default __exports__